import React from 'react';
import { ClipboardListIcon, GraduationCapIcon, LayoutDashboardIcon, MapPinIcon, ShieldAlertIcon, UsersIcon, WalletIcon } from 'lucide-react';
import { OperatorShell } from './OperatorShell';
import { Badge } from '../ui/Badge';
import { useNetwork } from '../../contexts/NetworkContext';
import { naira } from '../../utils/format';
import { balancesFor, scoreFor } from '../../utils/network';
const GROUPS = [{
  label: 'Field',
  items: [{
    to: '/representative',
    label: 'Dashboard',
    icon: LayoutDashboardIcon,
    end: true
  }]
}];
const SECTIONS = [{
  label: 'Tasks and verification',
  icon: ClipboardListIcon
}, {
  label: 'Leads and intelligence',
  icon: MapPinIcon
}, {
  label: 'Earnings and payouts',
  icon: WalletIcon
}, {
  label: 'Training and certificates',
  icon: GraduationCapIcon
}, {
  label: 'Team',
  icon: UsersIcon
}, {
  label: 'Safety and incidents',
  icon: ShieldAlertIcon
}];
export function RepresentativeShell() {
  const network = useNetwork();
  const rep = network.currentRep;
  const campus = network.campuses.find(item => item.id === rep.campusId);
  const mine = network.earnings.filter(entry => entry.repId === rep.id);
  const balances = balancesFor(mine);
  const score = scoreFor(network.events.filter(item => item.repId === rep.id), network.verifications.filter(item => item.repId === rep.id), network.tasks.filter(item => item.assignedRepId === rep.id)).score;
  return <OperatorShell consoleKey="representative" consoleName="Representative console" scopeLine={`${rep.repCode} · ${campus?.name ?? 'Unassigned'} · ${rep.rank}`} groups={GROUPS} summary={<div data-id="element-5009" data-mp="3h963ckvjexr">
          <p className="text-[12px] text-ink-muted" data-id="element-5010" data-mp="8hx62nr2z644">Approved earnings</p>
          <p className="cz-num mt-1 text-xl font-semibold text-ink" data-id="element-5011" data-mp="8g2mpdvgjm25">{naira(balances.approved)}</p>
          <div className="mt-2 flex flex-wrap gap-1.5" data-id="element-5012" data-mp="3psdd6smf2pdd">
            <Badge tone={rep.status === 'Probation' ? 'warn' : 'ok'} data-id="element-5013" data-mp="3uobvbyh5jb5c">{rep.status}</Badge>
            <Badge tone="brand" data-id="element-5014" data-mp="3bl0b7yk6uu0v">Score {score}</Badge>
          </div>
          <ul className="mt-4 space-y-1.5 border-t border-line pt-3" data-id="element-5015" data-mp="36u1sksbq9jug">
            {SECTIONS.map(section => {
        const Icon = section.icon;
        return <li key={section.label} className="flex items-center gap-2 text-[12px] text-ink-muted" data-id="element-5016" data-mp="31sulywlbmqpd">
                  <Icon className="h-3.5 w-3.5 shrink-0 text-ink-subtle" data-id="element-5017" data-mp="2wtrhped60oig" />
                  {section.label}
                </li>;
      })}
          </ul>
        </div>} data-id="element-5008" data-mp="cih4dune4fru" />;
}